var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "交货单",
            visible: _vm.show,
            size: "90%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                disabled: _vm.type == "查看" || _vm.form.status > 1,
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "交货单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SAP交货单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sapDeliverySn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapDeliverySn", $$v)
                                  },
                                  expression: "form.sapDeliverySn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单据类型",
                                prop: "deliveryType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.form.deliveryType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryType", $$v)
                                    },
                                    expression: "form.deliveryType",
                                  },
                                },
                                _vm._l(_vm.salesTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "销售单号", prop: "orderSn" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.orderSn,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderSn", $$v)
                                    },
                                    expression: "form.orderSn",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectOrderSn },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SAP调仓单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sapTransferOrder,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapTransferOrder", $$v)
                                  },
                                  expression: "form.sapTransferOrder",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SAP销售单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择单号带出",
                                },
                                model: {
                                  value: _vm.form.sapSalesOrderSn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapSalesOrderSn", $$v)
                                  },
                                  expression: "form.sapSalesOrderSn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "售达方",
                                prop: "soldToPartyName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择单号带出",
                                },
                                model: {
                                  value: _vm.form.soldToPartyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "soldToPartyName", $$v)
                                  },
                                  expression: "form.soldToPartyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "送达方",
                                prop: "deliverySideName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择单号带出",
                                },
                                model: {
                                  value: _vm.form.deliverySideName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deliverySideName", $$v)
                                  },
                                  expression: "form.deliverySideName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "装运地点",
                                prop: "loadTransportSpotName",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    readonly: "",
                                    placeholder: "请点击图标选择",
                                  },
                                  model: {
                                    value: _vm.form.loadTransportSpotName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "loadTransportSpotName",
                                        $$v
                                      )
                                    },
                                    expression: "form.loadTransportSpotName",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.selectLoadTransportSpot },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "计划发货日期",
                                prop: "shipPlansTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.shipPlansTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "shipPlansTime", $$v)
                                  },
                                  expression: "form.shipPlansTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "财务入帐日期",
                                prop: "finalDeliveryTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  disabled: _vm.form.deliveryType === 3,
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.finalDeliveryTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "finalDeliveryTime", $$v)
                                  },
                                  expression: "form.finalDeliveryTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.deliveryType === 3
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "调拨日期",
                                    prop: "transferDate",
                                    disabled: true,
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "自动带出",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.form.transferDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "transferDate", $$v)
                                      },
                                      expression: "form.transferDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "拣配日期", prop: "pickingTime" },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.pickingTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "pickingTime", $$v)
                                  },
                                  expression: "form.pickingTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据状态", prop: "status" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.statusArr[_vm.form.status],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statusArr,
                                      _vm.form.status,
                                      $$v
                                    )
                                  },
                                  expression: "statusArr[form.status]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "交货工厂", prop: "factoryId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "选择单号带出",
                                  },
                                  model: {
                                    value: _vm.form.factoryId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "factoryId", $$v)
                                    },
                                    expression: "form.factoryId",
                                  },
                                },
                                _vm._l(_vm.factoryOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "中间公司",
                                prop: "middleCompanyId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "选择单号带出",
                                },
                                model: {
                                  value: _vm.form.middleCompanyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "middleCompanyName", $$v)
                                  },
                                  expression: "form.middleCompanyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createUser,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createUser", $$v)
                                  },
                                  expression: "form.createUser",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createTime", $$v)
                                  },
                                  expression: "form.createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "note", $$v)
                                  },
                                  expression: "form.note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "订单明细" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activePaneName,
                        callback: function ($$v) {
                          _vm.activePaneName = $$v
                        },
                        expression: "activePaneName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "配件", name: "mountings" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addMountingsLine()
                                    },
                                  },
                                },
                                [_vm._v("配件明细")]
                              ),
                            ],
                            1
                          ),
                          !_vm.showObj.mountings
                            ? _c(
                                "el-table",
                                {
                                  ref: "mountingsTable",
                                  attrs: {
                                    height: "400px",
                                    data: _vm.form.mountingsList,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "序号",
                                      width: "50",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料编码",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productCode",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productCode",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      380125132
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productName",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      885578700
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "订单数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "qty" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value: scope.row.qty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "qty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.qty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1005378272
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "已交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "deliveredQuantity",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .deliveredQuantity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "deliveredQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.deliveredQuantity",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      137732768
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "未交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "undeliveredQuantity",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .undeliveredQuantity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "undeliveredQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.undeliveredQuantity",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3383042592
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "存储地点",
                                      align: "left",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "mountingsList." +
                                                      scope.$index +
                                                      ".warehouseCode",
                                                    rules:
                                                      _vm.mountingsList
                                                        .warehouseCode,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .warehouseCode,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "warehouseCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.warehouseCode",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          slot: "append",
                                                          icon: "el-icon-search",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectWarehouse(
                                                              scope.$index,
                                                              scope.row
                                                                .productType
                                                            )
                                                          },
                                                        },
                                                        slot: "append",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1328001858
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "当前交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "mountingsList." +
                                                      scope.$index +
                                                      ".deliveryQty",
                                                    rules:
                                                      _vm.mountingsList
                                                        .deliveryQty,
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.deliveryQty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "deliveryQty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.deliveryQty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2140942599
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "投入数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "inputQty" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: false,
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value: scope.row.inputQty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "inputQty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.inputQty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4204199923
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单位",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "unit" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.unit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.unit",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1526910572
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "批次号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "batch" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.batch,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "batch",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.batch",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1095197900
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车辆ID",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "carId" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.carId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "carId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.carId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2990388108
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车牌",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "carNo" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.carNo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "carNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.carNo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1819983564
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "品牌",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "brand" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.brand,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "brand",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.brand",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      839057932
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "车系",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "series" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.series,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "series",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.series",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4045277228
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "年款",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { prop: "modelYear" },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.modelYear,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "modelYear",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.modelYear",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1129535820
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "发动机型号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "engineModel",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.engineModel,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "engineModel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.engineModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2941621452
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "变速箱型号",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "transmissionModel",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .transmissionModel,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "transmissionModel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.transmissionModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3860506124
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "排量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "displacement",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.displacement,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "displacement",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.displacement",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      140003564
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "说明",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "note" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                    },
                                                    model: {
                                                      value: scope.row.note,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "note",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.note",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3944887472
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      fixed: "right",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleMountingsDelete(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1993727048
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "废料", name: "flotsam" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addFlotsamLine()
                                    },
                                  },
                                },
                                [_vm._v("废料明细")]
                              ),
                            ],
                            1
                          ),
                          !_vm.showObj.flotsam
                            ? _c(
                                "el-table",
                                {
                                  ref: "flotsamTable",
                                  attrs: {
                                    height: "400px",
                                    data: _vm.form.flotsamList,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "序号",
                                      width: "50",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料编码",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productCode",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productCode",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      380125132
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "物料名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "productName",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.productName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "productName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.productName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      885578700
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "订单数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "qty" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value: scope.row.qty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "qty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.qty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1005378272
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "已交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "deliveredQuantity",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .deliveredQuantity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "deliveredQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.deliveredQuantity",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      137732768
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "未交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "undeliveredQuantity",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .undeliveredQuantity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "undeliveredQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.undeliveredQuantity",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3383042592
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "存储地点",
                                      align: "left",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flotsamList." +
                                                      scope.$index +
                                                      ".warehouseCode",
                                                    rules:
                                                      _vm.flotsamList
                                                        .warehouseCode,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .warehouseCode,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "warehouseCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.warehouseCode",
                                                      },
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        attrs: {
                                                          slot: "append",
                                                          icon: "el-icon-search",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectWarehouse(
                                                              scope.$index,
                                                              scope.row
                                                                .productType
                                                            )
                                                          },
                                                        },
                                                        slot: "append",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2150884290
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "当前交货数量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flotsamList." +
                                                      scope.$index +
                                                      ".deliveryQty",
                                                    rules:
                                                      _vm.flotsamList
                                                        .deliveryQty,
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        scope.row.netWeight,
                                                      placeholder: "请输入",
                                                      min: "0",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.deliveryQty,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "deliveryQty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.deliveryQty",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1095172990
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "磅单重量",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { prop: "netWeight" },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectNetWeight(
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.netWeight ||
                                                            "选择磅单"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  scope.row.netWeight
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            color: "#F56C6C",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.cancelNetWeight(
                                                                scope.$index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("取消引用")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      561819133
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单位",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "unit" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      placeholder: "自动生成",
                                                    },
                                                    model: {
                                                      value: scope.row.unit,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.unit",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1526910572
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "说明",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                { attrs: { prop: "note" } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                    },
                                                    model: {
                                                      value: scope.row.note,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "note",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.note",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3944887472
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      fixed: "right",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleFlotsamDelete(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1772478168
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "ZP03投入", name: "spareParts" } },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "sparePartsTable",
                              attrs: {
                                height: "400px",
                                data: _vm.form.crmSalesOrdersLooseItemsModels,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "crmSalesOrdersLooseItemsModels." +
                                                scope.$index +
                                                ".qty",
                                              rules:
                                                _vm
                                                  .crmSalesOrdersLooseItemsModels
                                                  .qty,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                min: "0",
                                                disabled: true,
                                                placeholder: "请输入",
                                                type: "number",
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "单位",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "unit" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "unit",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.unit",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "batch" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.batch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "batch",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.batch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "OE",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "150",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "oeCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.oeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "oeCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.oeCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车辆ID",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "carId" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.carId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "carId",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.carId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车牌",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "carNo" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.carNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "carNo",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.carNo",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "品牌",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "brand" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.brand,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "brand",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.brand",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车系",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "series" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.series,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "series",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.series",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "年款",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "modelYear" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.modelYear,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "modelYear",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.modelYear",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "发动机型号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "engineModel" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.engineModel,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "engineModel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.engineModel",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "变速箱型号",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "transmissionModel",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value:
                                                  scope.row.transmissionModel,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "transmissionModel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.transmissionModel",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "排量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "displacement" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.displacement,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "displacement",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.displacement",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "说明",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                  width: "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "note" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "请输入",
                                              },
                                              model: {
                                                value: scope.row.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: [3].includes(_vm.form.status),
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmShipment()
                            },
                          },
                        },
                        [_vm._v("确认发货")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择售达方",
            visible: _vm.showObj.soldToParty,
            width: "50%",
            "before-close": _vm.soldToPartyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "soldToParty", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.soldToParty.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.soldToParty,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.soldToParty.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getSoldToPartyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.soldToParty,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleSoldToPartySelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户类型",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.customerType == 1
                          ? _c("span", [_vm._v("固定")])
                          : _vm._e(),
                        scope.row.customerType == 2
                          ? _c("span", [_vm._v("零星")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "经营类别",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.operateCategory == 1
                          ? _c("span", [_vm._v("配件")])
                          : _vm._e(),
                        scope.row.operateCategory == 2
                          ? _c("span", [_vm._v("废钢")])
                          : _vm._e(),
                        scope.row.operateCategory == 3
                          ? _c("span", [_vm._v("有色")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系人",
                  align: "left",
                  prop: "contacts",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系方式",
                  align: "left",
                  prop: "contactsPhone",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "详细地址",
                  align: "left",
                  prop: "address",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据状态",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.soldToParty.total,
                  page: _vm.pagination.soldToParty.current,
                  limit: _vm.pagination.soldToParty.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.soldToParty,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.soldToParty, "size", $event)
                  },
                  pagination: _vm.getSoldToPartyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.soldToPartyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.soldToPartyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择送达方",
            visible: _vm.showObj.deliverySide,
            width: "50%",
            "before-close": _vm.deliverySideClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "deliverySide", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.condition.deliverySide.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.deliverySide,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.deliverySide.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getDeliverySideDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.deliverySide,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleDeliverySideSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户编码",
                  align: "left",
                  prop: "customerApplyNo",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户名称",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户类型",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.customerType == 1
                          ? _c("span", [_vm._v("固定")])
                          : _vm._e(),
                        scope.row.customerType == 2
                          ? _c("span", [_vm._v("零星")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "经营类别",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.operateCategory == 1
                          ? _c("span", [_vm._v("配件")])
                          : _vm._e(),
                        scope.row.operateCategory == 2
                          ? _c("span", [_vm._v("废钢")])
                          : _vm._e(),
                        scope.row.operateCategory == 3
                          ? _c("span", [_vm._v("有色")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系人",
                  align: "left",
                  prop: "contacts",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "联系方式",
                  align: "left",
                  prop: "contactsPhone",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "详细地址",
                  align: "left",
                  prop: "address",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据状态",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.deliverySide.total,
                  page: _vm.pagination.deliverySide.current,
                  limit: _vm.pagination.deliverySide.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.deliverySide,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.deliverySide, "size", $event)
                  },
                  pagination: _vm.getDeliverySideDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.deliverySideClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deliverySideConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择中间公司",
            visible: _vm.showObj.middleCompany,
            width: "60%",
            "before-close": _vm.middleCompanyClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "middleCompany", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入销售客户名称" },
                    model: {
                      value: _vm.condition.middleCompany.customerApplyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.middleCompany,
                          "customerApplyName",
                          $$v
                        )
                      },
                      expression: "condition.middleCompany.customerApplyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMiddleCompanyDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.middleCompany,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleMiddleCompanySelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织编码",
                  align: "left",
                  prop: "salesOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售客户",
                  align: "left",
                  prop: "customerApplyName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织编码",
                  align: "left",
                  prop: "purchasingOrganizationCode",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购组织",
                  align: "left",
                  prop: "purchasingOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购供应商",
                  align: "left",
                  prop: "supplierName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.middleCompany.total,
                  page: _vm.pagination.middleCompany.current,
                  limit: _vm.pagination.middleCompany.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.middleCompany,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getMiddleCompanyDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.middleCompanyClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.middleCompanyConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择销售单号",
            visible: _vm.showObj.orderSn,
            width: "70%",
            "before-close": _vm.orderSnClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "orderSn", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入销售订单号" },
                    model: {
                      value: _vm.condition.orderSn.sn,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.orderSn, "sn", $$v)
                      },
                      expression: "condition.orderSn.sn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { clearable: "", placeholder: "请输入售达方" },
                    model: {
                      value: _vm.condition.orderSn.soldToPartyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.orderSn, "soldToPartyName", $$v)
                      },
                      expression: "condition.orderSn.soldToPartyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("div", {
                    staticStyle: { "margin-left": "5px", width: "1px" },
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择单据类型" },
                      model: {
                        value: _vm.condition.orderSn.deliveryType,
                        callback: function ($$v) {
                          _vm.$set(_vm.condition.orderSn, "deliveryType", $$v)
                        },
                        expression: "condition.orderSn.deliveryType",
                      },
                    },
                    _vm._l(_vm.salesTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getOrderSnDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.orderSn, border: "", height: "300" },
              on: { "selection-change": _vm.handleOrderSnSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单状态",
                  align: "left",
                  prop: "status",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据类型",
                  align: "left",
                  prop: "deliveryType",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.deliveryType == 1
                          ? _c("span", [_vm._v("交货单")])
                          : _vm._e(),
                        scope.row.deliveryType == 3
                          ? _c("span", [_vm._v("不定价交货单")])
                          : _vm._e(),
                        scope.row.deliveryType == 2
                          ? _c("span", [_vm._v("退货交货单")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售订单号",
                  align: "left",
                  prop: "sn",
                  "show-overflow-tooltip": "",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.addAccessoryDetailLine(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.sn))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SAP销售单号",
                  align: "left",
                  prop: "sapOrderSn",
                  width: "130",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "售达方",
                  align: "left",
                  prop: "soldToPartyName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "送达方",
                  align: "left",
                  prop: "deliverySideName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "备注",
                  align: "left",
                  prop: "note",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.orderSn.total,
                  page: _vm.pagination.orderSn.current,
                  limit: _vm.pagination.orderSn.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.orderSn, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.orderSn, "size", $event)
                  },
                  pagination: _vm.getOrderSnDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.orderSnClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.orderSnConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择退货单号",
            visible: _vm.showObj.returnOrderSn,
            width: "70%",
            "before-close": _vm.returnOrderSnClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "returnOrderSn", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入退货单号" },
                    model: {
                      value: _vm.condition.returnOrderSn.sn,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.returnOrderSn, "sn", $$v)
                      },
                      expression: "condition.returnOrderSn.sn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { clearable: "", placeholder: "请输入售达方" },
                    model: {
                      value: _vm.condition.returnOrderSn.soldToPartyName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.returnOrderSn,
                          "soldToPartyName",
                          $$v
                        )
                      },
                      expression: "condition.returnOrderSn.soldToPartyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getOrderSnDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.returnOrderSn,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleReturnOrderSnSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单状态",
                  align: "left",
                  prop: "status",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 1
                          ? _c("span", [_vm._v("制单")])
                          : _vm._e(),
                        scope.row.status == 2
                          ? _c("span", [_vm._v("审核中")])
                          : _vm._e(),
                        scope.row.status == 3
                          ? _c("span", [_vm._v("审核完成")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据类型",
                  align: "left",
                  prop: "salesName",
                  "show-overflow-tooltip": "",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "退货订单号",
                  align: "left",
                  prop: "sn",
                  "show-overflow-tooltip": "",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售订单号",
                  align: "left",
                  prop: "salesOrderSn",
                  "show-overflow-tooltip": "",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SAP销售单号",
                  align: "left",
                  prop: "sapOrderSn",
                  width: "130",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售组织",
                  align: "left",
                  prop: "salesOrganizationName",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "售达方",
                  align: "left",
                  prop: "soldToPartyName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "送达方",
                  align: "left",
                  prop: "deliverySideName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "备注",
                  align: "left",
                  prop: "note",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建人",
                  align: "left",
                  prop: "createUser",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  align: "left",
                  prop: "createTime",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.returnOrderSn.total,
                  page: _vm.pagination.returnOrderSn.current,
                  limit: _vm.pagination.returnOrderSn.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.returnOrderSn,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.returnOrderSn,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getReturnOrderSnDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.returnOrderSnClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.returnOrderSnConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择装运地点",
            visible: _vm.showObj.loadTransportSpot,
            width: "60%",
            "before-close": _vm.loadTransportSpotClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "loadTransportSpot", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入装运点代码" },
                    model: {
                      value:
                        _vm.condition.loadTransportSpot.loadTransportSpotNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.loadTransportSpot,
                          "loadTransportSpotNumber",
                          $$v
                        )
                      },
                      expression:
                        "condition.loadTransportSpot.loadTransportSpotNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getLoadTransportSpotDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.loadTransportSpot,
                border: "",
                height: "300",
              },
              on: {
                "selection-change": _vm.handleLoadTransportSpotSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "装运点代码",
                  align: "left",
                  prop: "loadTransportSpotNumber",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "装运点描述",
                  align: "left",
                  prop: "loadTransportSpotName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.loadTransportSpot.total,
                  page: _vm.pagination.loadTransportSpot.current,
                  limit: _vm.pagination.loadTransportSpot.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.loadTransportSpot,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.loadTransportSpot,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getLoadTransportSpotDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.loadTransportSpotClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.loadTransportSpotConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择存储地点",
            visible: _vm.showObj.warehouse,
            width: "60%",
            "before-close": _vm.warehouseClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "warehouse", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入存储代码" },
                    model: {
                      value: _vm.condition.warehouse.warehouseNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.warehouse,
                          "warehouseNumber",
                          $$v
                        )
                      },
                      expression: "condition.warehouse.warehouseNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getWarehouseDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.warehouse, border: "", height: "300" },
              on: { "selection-change": _vm.handleWarehouseSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "存储代码",
                  align: "left",
                  prop: "warehouseNumber",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "存储描述",
                  align: "left",
                  prop: "warehouseName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.warehouse.total,
                  page: _vm.pagination.warehouse.current,
                  limit: _vm.pagination.warehouse.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.warehouse, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.warehouse, "size", $event)
                  },
                  pagination: _vm.getWarehouseDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.warehouseClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.warehouseConfirm },
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.allWarehouseConfirm },
                },
                [_vm._v("批量填充")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品配料",
            visible: _vm.showObj.mountings,
            width: "70%",
            "before-close": _vm.mountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "mountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.mountings.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productName", $$v)
                      },
                      expression: "condition.mountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.mountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productCode", $$v)
                      },
                      expression: "condition.mountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.mountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "oeCode", $$v)
                      },
                      expression: "condition.mountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.mountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "carNo", $$v)
                      },
                      expression: "condition.mountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.mountings,
                  expression: "loadingObj.mountings",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.mountings, border: "", height: "300" },
              on: { "selection-change": _vm.handleMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "拆解类型",
                  align: "left",
                  prop: "separateType",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.format.formatEnumDesc(
                                "Separate_Type_Code",
                                scope.row.separateType
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.mountings.total,
                  page: _vm.pagination.mountings.current,
                  limit: _vm.pagination.mountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "size", $event)
                  },
                  pagination: _vm.getMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品废料",
            visible: _vm.showObj.flotsam,
            width: "60%",
            "before-close": _vm.flotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "flotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.flotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productName", $$v)
                      },
                      expression: "condition.flotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.flotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productCode", $$v)
                      },
                      expression: "condition.flotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.flotsam,
                  expression: "loadingObj.flotsam",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.flotsam, border: "", height: "300" },
              on: { "selection-change": _vm.handleFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "未交货数量",
                  align: "left",
                  prop: "undeliveredQuantity",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "已交货数量",
                  align: "left",
                  prop: "deliveredQuantity",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.flotsam.total,
                  page: _vm.pagination.flotsam.current,
                  limit: _vm.pagination.flotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "size", $event)
                  },
                  pagination: _vm.getFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.flotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.flotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品明细",
            visible: _vm.showObj.accessoryDetail,
            width: "70%",
            "before-close": _vm.accessoryDetailClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "accessoryDetail", $event)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.accessoryDetail,
                  expression: "loadingObj.accessoryDetail",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.accessoryDetail,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleAccessoryDetailChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  prop: "oeCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "拆解类型",
                  align: "left",
                  prop: "separateType",
                  width: "120",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.format.formatEnumDesc(
                                "Separate_Type_Code",
                                scope.row.separateType
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  prop: "carId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.accessoryDetail.total,
                  page: _vm.pagination.accessoryDetail.current,
                  limit: _vm.pagination.accessoryDetail.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.accessoryDetail,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.accessoryDetail,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getAccessoryDetail,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.accessoryDetailClose } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择磅单重量",
            visible: _vm.showObj.netWeight,
            width: "70%",
            "before-close": _vm.netWeightClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "netWeight", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入磅单号" },
                    model: {
                      value: _vm.condition.netWeight.sn,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.netWeight, "sn", $$v)
                      },
                      expression: "condition.netWeight.sn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.netWeight.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.netWeight, "carNo", $$v)
                      },
                      expression: "condition.netWeight.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.netWeight.carTypeItemName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.netWeight,
                          "carTypeItemName",
                          $$v
                        )
                      },
                      expression: "condition.netWeight.carTypeItemName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择过磅日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.condition.netWeight.weighDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.netWeight, "weighDate", $$v)
                      },
                      expression: "condition.netWeight.weighDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNetWeightDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.netWeight, border: "", height: "300" },
              on: { "selection-change": _vm.handleNetWeightSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "磅单号",
                  align: "left",
                  prop: "sn",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料",
                  align: "left",
                  prop: "carTypeItemName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "称重时间",
                  align: "left",
                  prop: "weighDate",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "称重人",
                  align: "left",
                  prop: "weighPersonnel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "空重",
                  align: "left",
                  prop: "weighScaleNull",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "净重",
                  align: "left",
                  prop: "weighNet",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.netWeightClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.netWeightConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }